module.exports = "<span class=\"js-text dropdown-text\">{{#if hasValue}}{{#if text}}{{text}}{{else}}&nbsp{{/if}}{{else}}{{localize 'CORE.FORM.EDITORS.DROPDOWN.NOTSET'}}{{/if}}</span> <div class=svg-icons-wrp> <div class=svg-icons-wrp__empty> <svg class=\"svg-icons svg-icons_dropdown\"><use xlink:href=#icon-dropdown /> </svg> </div> {{#if allowEmptyValue}} <div class=\"js-clear-button svg-icons-wrp__remove\"> <svg class=\"svg-icons svg-icons_remove\"><use xlink:href=#icon-remove /> </svg> </div> {{/if}} </div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/dropdown/templates/dropdownButton.hbs
// module id = 662
// module chunks = 0